import { Box, Typography } from '@mui/material';
import { PoliciesDataType, ComplianceDocumentTypeField } from 'domain/shared/compliance';
import ComplianceSectionBlock from 'domain/people/employee/compliance/shared/ComplianceSectionBlock';
import LinkToSignComplianceDocumentButton from 'domain/people/employee/compliance/shared/buttons/LinkToSignComplianceDocumentButton';
import { isComplianceRegistryItemNotSigned } from 'domain/people/employee/compliance/shared/complianceRegistryPortalRules';
import { Alert } from 'framework/ui/mui-builder';
import { DataGridLayoutGrid, GroupedList, ListLoadingDecorator, useListContext } from 'framework/list';
import { DateField, VersionField as PolicyVersionField } from 'framework/ui/field';
import { DATE_FORMAT } from 'framework/utils';
import EmployeePortalComplianceNameField from './field/EmployeePortalComplianceNameField';
import { PortalComplianceGroupedEntry } from './types';

const GroupedPortalComplianceGrid = () => {
  const { data = {}, loading } = useListContext();
  const groupedEntries: PortalComplianceGroupedEntry[] = data.items || [];

  return (
    <ListLoadingDecorator loading={loading} items={groupedEntries} hasBackground isInitialPosition>
      <Box>
        {!loading && !groupedEntries.length && (
          <Alert color="info" sx={{ mt: 2 }}>
            No records found
          </Alert>
        )}

        {groupedEntries.map(({ key, items: entitiesArray }) => (
          <ComplianceSectionBlock
            key={key}
            sx={{ mb: 2, '&:last-of-type': { mb: 0 } }}
            header={
              <Typography variant="h6" color="primary">
                {key}
              </Typography>
            }
          >
            <GroupedList
              key={`${key}-${entitiesArray
                .map(
                  item =>
                    `${item.portalRowId}-${item.interactionTimeline?.length || 0}-${String(item.isPolicyAccepted)}`,
                )
                .join('|')}`}
              getDataMethod={() => Promise.resolve({ result: entitiesArray })}
            >
              <DataGridLayoutGrid
                rowKeySource="portalRowId"
                buttons={[
                  <LinkToSignComplianceDocumentButton
                    buttonText="Review and sign"
                    isVisible={(document: PoliciesDataType) => isComplianceRegistryItemNotSigned(document)}
                  />,
                ]}
                buttonContainerSize={1.5}
                isInitialLoaderPosition
                showPagination={false}
                showTotal={false}
                rowProps={{
                  sxRowContainer: {
                    border: 0,
                    my: 0,
                    borderBottom: '1px solid var(--mui-palette-TableCell-border)',
                  },
                  sx: {
                    alignItems: 'center',
                  },
                }}
              >
                <EmployeePortalComplianceNameField size={4.5} label="Name" source="policyPath" />

                <ComplianceDocumentTypeField size={2.5} label="Type" source="complianceType" />

                <PolicyVersionField source="policyVersion" label="Actual version" size={1.5} />

                <DateField label="Published on" source="policyCreatedAt" size={2} dateFormat={DATE_FORMAT.SIMPLE} />
              </DataGridLayoutGrid>
            </GroupedList>
          </ComplianceSectionBlock>
        ))}
      </Box>
    </ListLoadingDecorator>
  );
};

export default GroupedPortalComplianceGrid;
